import { createFileRoute } from '@tanstack/react-router';

import { AdminSettingsSectionPage } from '@pages/admin';

export const Route = createFileRoute(
  '/$locale/_authenticated/admin/settings/operations/$sectionId'
)({
  component: AdminOperationsSettingsSection,
});

function AdminOperationsSettingsSection() {
  const { sectionId } = Route.useParams();
  return <AdminSettingsSectionPage category="operations" sectionId={sectionId} />;
}
